import React from 'react'
import { styled } from 'src/ui/theme'
import { Header, Body } from 'src/ui/typography'
import { Button } from 'src/ui/molecules'
import { Image } from 'src/ui/atoms'

const Wrapper = styled.div`
  display: flex;
  width: 100%;
`

const Layout = styled.div`
  display: block;
  width: 50%;
  background-color: ${({ theme }) => theme.colors.gray.bg};
  padding: 56px 64px;
  padding-right: calc((100% - 1312px) / 2);

  @media (max-width: 1440px) {
    padding-right: 64px;
  }

  @media (max-width: 1024px) {
    padding: 24px 32px;
  }
`

const Content = styled.div`
  padding: 56px 64px;
  padding-left: calc((100% - 1312px) / 2);
  width: 50%;

  @media (max-width: 1440px) {
    padding-left: 64px;
  }

  @media (max-width: 1024px) {
    padding: 24px 32px;
  }
`

const Title = styled(Header)`
  color: ${({ theme }) => theme.colors.black.bg};
  margin-bottom: 24px;
`

const Subtitle = styled(Body)`
  color: ${({ theme }) => theme.colors.black.bg};
  margin-bottom: 24px;
`

type Props = {
  images: TImages
  onScrollToForm: () => void
  onScrollToReward: () => void
}

export const Intro: React.FC<Props> = ({
  images,
  onScrollToForm,
  onScrollToReward,
}) => {
  return (
    <Wrapper>
      <Content>
        <Title size="h3">
          Приведи друга в KODE — получи денежное вознаграждение!
        </Title>
        <Subtitle>
          Мы заинтересованы в развитии компании и всегда рады новым талантливым
          специалистам в нашей команде. За ценную рекомендацию мы готовы
          отблагодарить бонусом <a href="#reward" onClick={onScrollToReward}>от 5 до 100 тысяч рублей.</a>{' '}
        </Subtitle>
        <Button onClick={onScrollToForm}>Рекомендовать друга</Button>
      </Content>
      <Layout>
        <Image
          fluid={images['referral-intro']}
          objectFit="contain"
          height={348}
        />
      </Layout>
    </Wrapper>
  )
}
